import CandidateResultCard from './CandidateResultCard';

export default CandidateResultCard;
